import { render, staticRenderFns } from "./ViewContrato.vue?vue&type=template&id=24977b5c&"
import script from "./ViewContrato.vue?vue&type=script&lang=js&"
export * from "./ViewContrato.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports